module.exports = __webpack_public_path__ + "static/media/icons_Bilan L‚sion musculaire.c2eb1084.svg";